// Port of src/app/services/spotify/spotify-tokens.service.ts.
// localStorage key names are IDENTICAL to the Angular app so already-connected
// users stay connected after the React migration.

import { environment } from '../../config/environment';
import { useUserStore } from '../../stores/user-store';

export const accessTokenAddress = 'spotifyAccessToken';
export const refreshTokenAddress = 'spotifyRefreshToken';
export const codeVerifierAddress = 'spotifyCodeVerifier';
export const isSpotifyConnectedAddress = 'isSpotifyConnected';
export const clientIdAddress = 'spotifyClientId';
export const connectedUserEmailAddress = 'spotifyUserEmailAddress';

export function clearCredentials(): void {
  localStorage.removeItem(accessTokenAddress);
  localStorage.removeItem(refreshTokenAddress);
  localStorage.removeItem(codeVerifierAddress);
  localStorage.removeItem(isSpotifyConnectedAddress);
  localStorage.removeItem(clientIdAddress);
  localStorage.removeItem(connectedUserEmailAddress);

  const userStore = useUserStore.getState();
  const user = userStore.user;
  if (user) {
    user.isSpotifyConnected = false;
    userStore.setUser(user);
  }
}

export function setRefreshToken(refreshToken: string): void {
  if (localStorage.getItem(isSpotifyConnectedAddress)) {
    localStorage.setItem(refreshTokenAddress, refreshToken);
  } else {
    environment.spotifyRefreshToken = refreshToken;
  }
}

export function setUserId(clientId: string): void {
  localStorage.setItem(clientIdAddress, clientId);
}

export function setIsSpotifyConnected(): void {
  localStorage.setItem(isSpotifyConnectedAddress, 'true');
}

export function setTokens(accessToken: string, refreshToken: string, email: string): void {
  localStorage.setItem(accessTokenAddress, accessToken);
  localStorage.setItem(refreshTokenAddress, refreshToken);
  localStorage.setItem(connectedUserEmailAddress, email);
}

export function setCodeVerifier(codeVerifier: string): void {
  localStorage.setItem(codeVerifierAddress, codeVerifier);
}

export function getAccessToken(): string {
  return localStorage.getItem(accessTokenAddress)!;
}

export function getCodeVerifierAddress(): string {
  return localStorage.getItem(codeVerifierAddress)!;
}

export function getConnectedUserEmailAddress(): string {
  return localStorage.getItem(connectedUserEmailAddress)!;
}

export function getRefreshToken(): string {
  if (getIsSpotifyConnected() && useUserStore.getState().user?.isSubscribed) {
    return localStorage.getItem(refreshTokenAddress)!;
  } else {
    return environment.spotifyRefreshToken;
  }
}

export function getUserId(): string {
  if (getIsSpotifyConnected() && useUserStore.getState().user?.isSubscribed) {
    return localStorage.getItem(clientIdAddress)!;
  } else {
    return environment.spotifyDefaultUserId;
  }
}

export function getIsSpotifyConnected(): boolean {
  const value = localStorage.getItem(isSpotifyConnectedAddress);
  return value === 'true';
}
